import { createSpotlightTourDebugSection } from '../../debug_tools/createSpotlightTourDebugSection'
import { registerDebugPanelSection } from '../../debug_tools/debugRegistry'
import { SPOTLIGHT_TOUR_DEBUG_IDS } from '../../debug_tools/spotlightTourDebugConfig'

registerDebugPanelSection({
  id: 'brand-refresh-nav-tour',
  title: 'Brand refresh spotlight tour',
  removeBy: '2026-12-01',
  order: 20,
  Component: createSpotlightTourDebugSection(SPOTLIGHT_TOUR_DEBUG_IDS.BRAND_REFRESH_NAV),
})
